// extracted by mini-css-extract-plugin
module.exports = {"device":"_b171ab5","video":"_7b0193b","videoWrap":"_38fbcb6","videoIframe":"_5610865"};